import React from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import { Menu, MenuItem } from "@mui/material";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";
import SemButton from "../../../../common/components/Button";

const TableSettings = ({ columns, updateProjectTableCol }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const handleToggle = (value) => () => {
    updateProjectTableCol(value);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const columnsList = columns?.filter((item) => !item.ignore);
  if (columnsList?.length === 0) return null;

  return (
    <>
      <SemButton
        title={t("projects.customize_table_button.tooltip")}
        onClick={handleClick}
        name={t("projects.customize_table_button.title")}
        icon={<FilterListIcon />}
      />

      <Menu
        id={"table-settings"}
        anchorEl={anchorEl}
        MenuListProps={{
          "aria-labelledby": "long-button",
        }}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        sx={{
          "& .MuiList-root": {
            minWidth: 180,
            maxWidth: 300,
            maxHeight: 350,
          },
        }}
      >
        <MenuItem>
          <ListItemText>
            {" "}
            {t("projects.customize_table_button.columns.title")}
          </ListItemText>
        </MenuItem>
        <Divider />
        {columnsList?.map((headerText) => {
          const labelId = `checkbox-list-label-${headerText.label}`;
          return (
            <MenuItem
              key={labelId}
              className="heading-small"
              style={{ color: "black" }}
              onClick={handleToggle(headerText.label)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={headerText.show}
                  disableRipple
                  inputProps={{ "aria-labelledby": labelId }}
                />
              </ListItemIcon>{" "}
              <ListItemText
                id={labelId}
                primary={headerText.label}
                sx={{
                  textTransform: "capitalize",
                  whiteSpace: "normal",
                }}
              />
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default React.memo(TableSettings);
